import React, { useEffect, useState,useRef  } from 'react';
import powerBISettings from '../../configs/powerBISettings';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import { Typography, Box, Tooltip, Link } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import '../../style/Subscription.css';
import { FormHelperText, TextField, Checkbox, ListItemText } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { timeZones } from "../../utils/timezones";
import { LocalizationProvider, DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale';
import { GlobalStyles } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/icons/Info_Filled.svg';
import Dialog from '@mui/material/Dialog';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

function SubscriptionMgt(props) {
  // Enhanced parseDate to handle time-only strings like '17:00:00'
  const parseDate = (val) => {
    if (!val) return null;
    if (val instanceof Date) return val;
    if (typeof val === 'string') {
      // If it's a time-only string (e.g. '17:00:00')
      if (/^\d{2}:\d{2}:\d{2}$/.test(val)) {
        const [h, m, s] = val.split(':').map(Number);
        const d = new Date();
        d.setHours(h, m, s, 0);
        return d;
      }
      // Otherwise, try to parse as a full date string
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  };

  const { isAuthenticated, userType, actionType, users, reportNotificationObject, hvaObjects, tenantEmailBodyTemplates, isServiceOrTenantAdminOrSupportImpUser, onSubscriptionAction } = props;
  const [title, setTitle] = useState("");
  const [reportFormats, setReportFormats] = useState([
    { name: "pdf" },
    { name: "pptx" }
  ]);
  const [emailList, setEmailList] = useState([]);
  const [buttonText, setButtonText] = useState(actionType === "add" ? "Create" : "Update");
  const [selectedObjectId, setSelectedObjectId] = useState(reportNotificationObject?.ObjectId || '');
  const [displayName, setDisplayName] = useState(reportNotificationObject?.DisplayName || '');
  const [contentPackFormat, setContentPackFormat] = useState(reportNotificationObject?.ReportFormat || reportFormats[0].name);
  const [rowLevelSecurityUser, setRowLevelSecurityUser] = useState(reportNotificationObject?.RLSUser || '');
  const [subject, setSubject] = useState(reportNotificationObject?.Subject || '');
  const [timeZone, setTimeZone] = useState(reportNotificationObject?.Timezone || '');
  const [startDate, setStartDate] = useState(parseDate(reportNotificationObject?.StartDate));
  const [featureName, setFeatureName] = useState('');
  
  const [endDate, setEndDate] = useState(parseDate(reportNotificationObject?.EndDate));

  const [sendTime, setSendTime] = useState(parseDate(reportNotificationObject?.SendReportTime));

  const [recurrencePattern, setRecurrencePattern] = useState(reportNotificationObject?.RecurrencePattern || 'Daily');

  const [nextRecurrenceDate, setNextRecurrenceDate] = useState(parseDate(reportNotificationObject?.NextRecurrenceDate));
  const [emailTemplate, setEmailTemplate] = useState(tenantEmailBodyTemplates[0] || '');
  const [customMessage, setCustomMessage] = useState(reportNotificationObject?.EmailBodyTemplate || '');

  const [contentPackError, setContentPackError] = useState(false);
  const [displayNameError, setDisplayNameError] = useState(false);
  const [helperText, setHelperText] = useState('');
  const [rowLevelSecurityUserError, setRowLevelSecurityUserError] = useState(false);
  const [subjectError, setSubjectError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [sendTimeError, setSendTimeError] = useState(false);


  const [isDirty, setIsDirty] = useState(false);

  const [emails, setEmails] = React.useState([]);
  const [manualEmails, setManualEmails] = React.useState('');
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailDialogSelection, setEmailDialogSelection] = useState([]);
  const recurrencePatterns = ['Daily', 'Weekly', 'Monthly'];
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Time zone state and options
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [timeZoneError, setTimeZoneError] = useState(false);
  const [selectedWeekDays, setSelectedWeekDays] = useState([]);
  const [selectedDayOfMonth, setSelectedDayOfMonth] = useState('');
  const [selectedWeekDaysError, setSelectedWeekDaysError] = useState(false);
  const [selectedDayOfMonthError, setSelectedDayOfMonthError] = useState(false);

  const [manualEmailError, setManualEmailError] = useState("");
  const [searchText, setSearchText] = useState("");

const formRef = useRef(null);


useEffect(() => {
  if (!formRef.current) return;
  // Reset session timer when dialog opens  
  if (props.resetSessionTimer) {  
    props.resetSessionTimer();  
  } 
  const firstEnabledInput = formRef.current.querySelector(
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
  );

  firstEnabledInput?.focus();
}, [props.openSubscriptionDialog]); // Run every time dialog opens

  const handleEmailList = (event) => {
    const { target: { value } } = event;
    setEmails(typeof value === 'string' ? value.split(';') : value);
     // Clear error if any email is selected
    setEmailError(false);
  };

  const handleManualEmailsChange = (event) => {
    const { value } = event.target;
    setManualEmails(value);

    // Update emails state on change
    const emailArray = value.split(';').map(email => email.trim()).filter(email => email);
    setEmails(prevEmails => {
      // Merge and remove duplicates
      const merged = [...new Set([...prevEmails, ...emailArray])];
      return merged;
    });
  };

  const handleTimeZoneChange = (event) => {
    setTimeZone(event.target.value);
    setTimeZoneError(false);
  };

  const handleRecurrencePatternChange = (event) => {
/*     setSelectedWeekDays([]);
    setSelectedDayOfMonth(''); */

    setRecurrencePattern(event.target.value);
   setSubject(getReportNotificationSubject('ADD', event.target.value, featureName));
  };

  useEffect(() => {
    setTimeZoneOptions(timeZones);
    if (reportNotificationObject?.Timezone) {
      setTimeZone(reportNotificationObject.Timezone);
    } else {
      const tzDefault = timeZones.find(tz => tz.offset === 'UTC-05:00');
      setTimeZone(tzDefault ? tzDefault.id : 'UTC');
    }
  }, [timeZones, reportNotificationObject?.Timezone]);

  useEffect(() => {
    if (!reportNotificationObject?.RecurrencePattern) {
      setRecurrencePattern(recurrencePatterns[0]);
      setSelectedWeekDays([]);
      setSelectedDayOfMonth('');
    }

    if (reportNotificationObject?.RecurrencePattern === 'Weekly') {
      let weekDaysArr = [];
      const details = reportNotificationObject.RecurrencePatternDetails;
      if (Array.isArray(details)) {
        weekDaysArr = details;
      } else if (typeof details === 'string') {
        weekDaysArr = details.split(',').map(d => d.trim()).filter(Boolean);
      }
      setSelectedWeekDays(weekDaysArr);
    }

    if(reportNotificationObject?.RecurrencePattern === 'Monthly' ) {
      setSelectedDayOfMonth(reportNotificationObject.RecurrencePatternDetails);
    }
  }, [reportNotificationObject]);

  useEffect(() => {
    if (!reportNotificationObject?.ObjectId) {
      setSelectedObjectId('');
    }
    else {
      let featureName =  hvaObjects.find(obj => obj.ObjectId === reportNotificationObject.ObjectId)?.ObjectDisplayName;
      let version =  hvaObjects.find(obj => obj.ObjectId === reportNotificationObject.ObjectId)?.Version;
      setFeatureName(`${featureName} ${version}`);
    }
  }, [reportNotificationObject]);

  useEffect(() => {
    if (!reportNotificationObject?.ToEmailAddresses) {
      setEmails([]);
      setManualEmails('');
    } else if (Array.isArray(reportNotificationObject.ToEmailAddresses)) {
      setEmails(reportNotificationObject.ToEmailAddresses);
      setManualEmails(reportNotificationObject.ToEmailAddresses.join(';'));
    } else if (typeof reportNotificationObject.ToEmailAddresses === 'string') {
      setEmails(
        reportNotificationObject.ToEmailAddresses
          .split(';')
          .map(e => e.trim())
          .filter(e => e)
      );
      setManualEmails(reportNotificationObject.ToEmailAddresses);
    } else {
      setEmails([]);
      setManualEmails('');
    }
  }, [reportNotificationObject]);

  useEffect(() => {
    if (actionType === "add") {
      setTitle("New Subscription");
      setButtonText("Create");
    } else if (actionType === "edit") {
      setTitle("Update Subscription");
      setButtonText("Update");
    } else if (actionType === "delete") {
      setTitle("Delete Subscription");
      setButtonText("Delete");
    } else {
      setTitle(`${actionType} Subscription`);
      setButtonText("Submit");
    }

    //console.log("reportNotificationObject: ", reportNotificationObject);
    //console.log("hvaObjects: ", hvaObjects);
    //console.log("users: ", users);
    //console.log("tenantEmailBodyTemplates: ", tenantEmailBodyTemplates);
  }, [actionType, reportNotificationObject, hvaObjects, users, tenantEmailBodyTemplates]);

  useEffect(() => {
    if (Array.isArray(users)) {
      const uniqueEmails = [];
      users.forEach(user => {
        const email = user.UserDemographic?.Email;
        if (email && !uniqueEmails.includes(email)) {
          uniqueEmails.push(email);
        }
      });
      setEmailList(uniqueEmails);
    }
  }, [users]);

  // Handler for closing the dialog
  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const handleOpenEmailDialog = () => {
    // Merge selected emails and manual emails that match the list
    let manualFromInput = []
    if (typeof manualEmails === 'string' && manualEmails.length > 0){
      manualFromInput = manualEmails
      .split(';')
      .map(e => e.trim())
      .filter(e => e); 
    }
   
     
    const allSelected = Array.from(new Set([
      ...emails.filter(e => emailList.includes(e)),
      ...manualFromInput.filter(e => emailList.includes(e))
    ])); 
    setEmailDialogSelection(allSelected);
    setEmailDialogOpen(true);
  };

const handleCloseEmailDialog = (event, reason) => {
  // Prevent closing on backdrop click
  if (reason === 'backdropClick') {
    return;
  }
  setEmailDialogOpen(false);
};

  const handleEmailDialogChange = (email) => {
    setEmailDialogSelection(prev =>
      prev.includes(email)
        ? prev.filter(e => e !== email)
        : [...prev, email]
    );
  };

  const handleEmailDialogConfirm = () => {
    // Merge dialog selection with manual emails

    let manual = [];
    if (typeof manualEmails === 'string' && manualEmails.length > 0) {
      manual = manualEmails
        .split(';')
        .map(e => e.trim())
        .filter(e => !emailList.includes(e)); // Only keep emails NOT present in emailList
    }
    setEmails([...emailDialogSelection, ...manual]);
    setManualEmails([...emailDialogSelection, ...manual].join(';'));
    setEmailDialogOpen(false);
    setEmailError(false);
  };

// Utility function to get the report notification subject
function getReportNotificationSubject(operation, featureDisplayText, featureName) {
  let ret = "";
  switch (operation) {
    case 'ADD':
      ret = `${featureDisplayText} Content Pack Subscription for ${featureName}`;
      break;
    case 'UPDATE':
      // ret = `Update ${featureDisplayText} Subscription`;
      break;
    case 'DELETE':
      // ret = "Are you sure to delete?";
      break;
    default:
      ret = `${featureDisplayText} Subscription for ${featureName}`;
  }
  return ret;
}

// Utility to format Date to 24-hour time string
function formatTime24(date) {
  if (!date) return '';
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}

// Utility to format Date to MM-DD-YYYY string
function formatDateMMDDYYYY(date) {
  if (!date) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
}

  const handleSubscriptionAction = () => {
    if(isDirty) return;
    if (actionType === "add") {
      let recurrenceDetails = 'Every day';
      if (recurrencePattern === 'Weekly') {
        recurrenceDetails = selectedWeekDays.join(', ');
      }
      else if (recurrencePattern === 'Monthly') {
        recurrenceDetails = selectedDayOfMonth;
      }
      let nextDate = getNextRecurrenceDate(); 
      // Create a new reportNotificationObject from the existing one and add form values
      const newReportNotification = {
        ...reportNotificationObject,
        ObjectId: selectedObjectId,
        CcEmailAddresses: featureName,
        DisplayName: displayName,
        ReportFormat: contentPackFormat,
        RLSUser: rowLevelSecurityUser,
        ToEmailAddresses: Array.isArray(emails) ? emails.join(';') : emails,
        Subject: subject,
        Timezone: timeZone,
        StartDate: formatDateMMDDYYYY(startDate),
        EndDate: formatDateMMDDYYYY(endDate),
        SendReportTime: formatTime24(sendTime),
        NextRecurrenceDate: formatDateMMDDYYYY(nextDate),
        RecurrencePattern: recurrencePattern,
        DeviceType: 0,   
        RecurrencePatternDetails: recurrenceDetails,
        EmailBodyTemplate: customMessage,
      };
      console.log('Add new subscription:', newReportNotification);
      if (typeof onSubscriptionAction === 'function') {
        onSubscriptionAction('add', newReportNotification);
      }
    } else if (actionType === "edit") {
      // Update logic for edit
      let recurrenceDetails = 'Every day';
      if (recurrencePattern === 'Weekly') {
        recurrenceDetails = selectedWeekDays.join(', ');
      }
      else if (recurrencePattern === 'Monthly') {
        recurrenceDetails = selectedDayOfMonth;
      }
      let nextDate = getNextRecurrenceDate(); 
      const updatedReportNotification = {
        ...reportNotificationObject,
        ReportFormat: contentPackFormat,
        RLSUser: rowLevelSecurityUser,
        CcEmailAddresses: featureName,
        ToEmailAddresses: Array.isArray(emails) ? emails.join(',') : emails,
        Subject: subject,
        Timezone: timeZone,
        StartDate: formatDateMMDDYYYY(startDate),
        EndDate: formatDateMMDDYYYY(endDate),
        SendReportTime: formatTime24(sendTime),
        NextRecurrenceDate: formatDateMMDDYYYY(nextDate),
        RecurrencePattern: recurrencePattern,
        DeviceType: 0,   
        RecurrencePatternDetails: recurrenceDetails,
        EmailBodyTemplate: customMessage,
      };
      console.log('Edit subscription:', updatedReportNotification);
      if (typeof onSubscriptionAction === 'function') {
        onSubscriptionAction('edit', updatedReportNotification);
      }
    } else if (actionType === 'delete') {
      // Delete logic - call parent's onSubscriptionAction
      console.log('Delete subscription:', reportNotificationObject);
      if (typeof onSubscriptionAction === 'function') {
        onSubscriptionAction('delete', reportNotificationObject);
      }
    }
  };

  const handleContentPackChange = (event) => {
    setSelectedObjectId(event.target.value);
    // Clear error when user selects an option
    if (event.target.value) {
      setContentPackError(false);
      setHelperText('');
       let featureName =  hvaObjects.find(obj => obj.ObjectId === event.target.value)?.ObjectDisplayName;
      let version =  hvaObjects.find(obj => obj.ObjectId === event.target.value)?.Version;
      let featureDisplayName = `${featureName} ${version}`;
      setFeatureName(featureDisplayName);
      setSubject(getReportNotificationSubject('ADD', recurrencePattern, featureDisplayName));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // For delete action, bypass validation and perform delete immediately
   /*  if (actionType === 'delete') {
      handleSubscriptionAction();
      return;
    }
    ValidateFrom();
    if (!isDirty) {
      handleSubscriptionAction();
    } */
    event.preventDefault();
    if (ValidateFrom()) {
      handleSubscriptionAction();
    }

  };

// Utility to get weekday index from string (e.g. 'Mon' -> 1)
const getWeekdayIndex = (day) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days.indexOf(day);
};

const getNextRecurrenceDate = () => {
  if (actionType === 'delete') return true;
  let nextDate;
  if (recurrencePattern === 'Daily') {
    nextDate = startDate;
    setNextRecurrenceDate(nextDate);
  } else if (recurrencePattern === 'Weekly') {
    if (!selectedWeekDays.length) return false;
    // Use first selected weekday for calculation
    const selectedDay = selectedWeekDays[0];
    const startDay = startDate ? startDate.getDay() : 0;
    const weekDay = getWeekdayIndex(selectedDay);
    let offset = weekDay - startDay;
    if (offset < 0) offset += 7;
    nextDate = new Date(startDate);
    nextDate.setDate(nextDate.getDate() + offset);
    setNextRecurrenceDate(nextDate);
  } else if (recurrencePattern === 'Monthly') {
    const startDateDay = startDate ? startDate.getDate() : 1;
    const firstDateOfMonth = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), 1) : new Date();
    if (startDateDay <= Number(selectedDayOfMonth)) {
      nextDate = new Date(firstDateOfMonth);
      nextDate.setDate(Number(selectedDayOfMonth));
    } else {
      nextDate = new Date(firstDateOfMonth);
      nextDate.setDate(Number(selectedDayOfMonth));
      nextDate.setMonth(nextDate.getMonth() + 1);
    }
    setNextRecurrenceDate(nextDate);
  }
  return nextDate;
};

  const ValidateFrom = () => {
    let isValid = true;
    if (!selectedObjectId) {
      setContentPackError(true);
      isValid = false;
    } else {
      setContentPackError(false);
    }
    if (!displayName.trim()) {
      setDisplayNameError(true);
      isValid = false;
    } else {
      setDisplayNameError(false);
    }
    if (!rowLevelSecurityUser.trim()) {
      setRowLevelSecurityUserError(true);
      isValid = false;
    } else {
      setRowLevelSecurityUserError(false);
    }
    if (!emails || emails.length === 0) {
      setEmailError(true);
      isValid = false;
    } else {
      setEmailError(false);
    }
    if (!subject.trim()) {
      setSubjectError(true);
      isValid = false;
    } else {
      setSubjectError(false);
    }
    if (!timeZone) {
      setTimeZoneError(true);
      isValid = false;
    } else {
      setTimeZoneError(false);
    }
    if (!startDate) {
      setStartDateError(true);
      isValid = false;
    } else {
      setStartDateError(false);
    }
    if (!endDate) {
      setEndDateError(true);
      isValid = false;
    } else {
      setEndDateError(false);
    }
    if (!sendTime) {
      setSendTimeError(true);
      isValid = false;
    } else {
      setSendTimeError(false);
    }
    if(!selectedWeekDays.length && recurrencePattern === 'Weekly') {
      setSelectedWeekDaysError(true);
      isValid = false;
    } else {
      setSelectedWeekDaysError(false);
    }
    if (!selectedDayOfMonth && recurrencePattern === 'Monthly') {
      setSelectedDayOfMonthError(true);
      isValid = false;
    } else {
      setSelectedDayOfMonthError(false);
    }
    if (!endDate || !startDate || endDate <= startDate) {
      setEndDateError(true);
      isValid = false;
    } else {
      setEndDateError(false);
    }// Add manual email error validation  
    if (manualEmailError) {  
      isValid = false;  
    }
     setIsDirty(!isValid);
    return isValid;
  };

  function validateEmail(email) {
    // Simple email regex
    return /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,})$/.test(email);
  }

  // Filtered emails based on search input
const filteredEmails = emailList.filter(email =>
  email.toLowerCase().includes(searchText.toLowerCase())
);


  return (
    <form  ref={formRef} onSubmit={handleSubmit}>
      <GlobalStyles styles={{
        '.MuiPickersSectionList-root, .MuiPickersInputBase-sectionsContainer, .MuiPickersOutlinedInput-sectionsContainer': {
          paddingTop: '8.5px !important',
          paddingBottom: '8.5px !important',
        },
        '.MuiDialogContent-root': {
            overflowY: 'hidden !important',
          },
            }} />
      <Box sx={{ position: 'relative', minWidth: 400, padding: 0.2 }}>
        <DialogTitle sx={{ pr: 1, pl: 1, pt: 1, pb: 1, fontWeight: 700, fontSize: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {title}
          <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2, height: 'calc(80vh - 80px)', overflowY: 'auto  !important'}} tabIndex= {-1 }>
        {/* <Box sx={{ borderBottom: '1px solid #e0e0e0', mx: 1, mb: 1 }} /> */}
        <Box sx={{ p: 2 }}>
          <div className="flexWrapGap">
            <Box sx={{ flex: 1, minWidth: 250 }}>
              <Typography className="lableFont" title="Content Pack" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                Content Pack<span style={{ color: 'red' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small" sx={{ mt: 1 }} error={contentPackError}>

                <Select
                  labelId="ddlFeature-label"
                  id="ddlFeature"
                  value={selectedObjectId ? selectedObjectId : 'Select Content Pack'}
                  onChange={handleContentPackChange}
                  disabled={actionType !== 'add'}
                >
                  <MenuItem value="Select Content Pack"> Select Content Pack</MenuItem>
                  {Array.isArray(hvaObjects) && hvaObjects
                    .sort((a, b) => (a.Order - b.Order) || a.ObjectDisplayName.localeCompare(b.ObjectDisplayName))
                    .map(hvaobject => (
                      <MenuItem key={hvaobject.ObjectId} value={hvaobject.ObjectId}>
                        {hvaobject.ObjectDisplayName} {hvaobject.Version}
                      </MenuItem>
                    ))}
                </Select>
                {contentPackError && (
                  <FormHelperText error>Please select a Content Pack.</FormHelperText>
                )}
              </FormControl >
            </Box>
            <Box sx={{ flex: 1, minWidth: 250 }}>
              <Typography className="lableFont" title="Display Name" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                Subscription Display Name<span style={{ color: 'red' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                <TextField
                  error={displayNameError}
                  id="DisplayName"
                  name="ReportNotificationDisplayName"
                  placeholder="Subscription Display Name"
                  maxLength={510}
                  value={displayName}
                   onChange={e => {
                    setDisplayName(e.target.value);
                    if (e.target.value.trim()) setDisplayNameError(false);
                  }}
                  disabled={actionType !== 'add'}
                  fullWidth
                  size="small"
                  inputProps={{ maxLength: 510 }}
                />
                {displayNameError && (
                  <FormHelperText error>Display Name is required.</FormHelperText>
                )}
              </FormControl>
            </Box>
          </div>
          <div className="flexWrapGap">
            <Box sx={{ flex: 1, minWidth: 250 }}>
              <Typography className="lableFont" title="Content Pack format" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                Content Pack format<span style={{ color: 'red' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                <Select
                  labelId="ddlreportFormat-label"
                  id="ddlreportFormat"
                  value={contentPackFormat}
                  onChange={e => setContentPackFormat(e.target.value)}
                  disabled={actionType === 'delete'}
                >
                  {reportFormats.map(format => (
                    <MenuItem key={format.name} value={format.name}>
                      {format.name.toLowerCase()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {isServiceOrTenantAdminOrSupportImpUser && (
              <Box sx={{ flex: 1, minWidth: 250 }}>
                <Typography className="lableFont" title="Display Name" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                  Row Level Security User<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" sx={{ mt: 1 }} error={rowLevelSecurityUserError}>
                  <Select
                    labelId="ddlRowLevelSecurityUser-label"
                    id="ddlRowLevelSecurityUser"
                    value={rowLevelSecurityUser ? rowLevelSecurityUser : 'Select UPN'}
                    onChange={e => setRowLevelSecurityUser(e.target.value)}
                    disabled={actionType === 'delete'}
                  >
                    <MenuItem value="Select UPN"> Select UPN</MenuItem>
                    {Array.isArray(users) && users
                      .sort((a, b) => (a.Order - b.Order) || a.UserPrincipalName.localeCompare(b.UserPrincipalName))
                      .map(user => (
                        <MenuItem key={user.UserId} value={user.UserPrincipalName}>
                          {user.UserPrincipalName}
                        </MenuItem>
                      ))}
                  </Select>
                  {rowLevelSecurityUserError && (
                    <FormHelperText error>Row level security user is required.</FormHelperText>
                  )}
                </FormControl>
                {/* Validation message placeholder */}
              </Box>
            )}
          </div>
          <div className="flexWrapGap">
            <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 1, p: 2 }}>
              <Box sx={{ flex: 1, minWidth: 250 }} >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.1 }}>
                <Typography className="lableFont" title="Display Name" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                  To:<span style={{ color: 'red' }}>*</span>
                </Typography>
                   <Tooltip title="'ToEmail' addresses separate with semi colon (;)" tabIndex={-1}>
                   {/* <InfoIcon style={{ width: 30, height: 30, marginRight: 1, color: '#333' }} /> */}
                  <IconButton size="small" sx={{ p: 0.1 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" style={{ fill: '#1976d2' }}>
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M11 17h2v-6h-2v6zm0-8h2V7h-2v2zm1-7C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                    </svg>
                  </IconButton>
                </Tooltip>
                </Box>
                <FormControl fullWidth size="small" sx={{ mt: 1 }} error={emailError}>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={actionType === 'delete'}
                    value={manualEmails}
                    onChange={e => {
                      let value = e.target.value;
                      // Split and trim
                      let arr = value.split(';').map(x => x.trim()).filter(x => x);
                      setManualEmails(value);
                    }}
                    onBlur={() => {
                      // On blur, validate and merge manual emails with selected
                      const manualArr = manualEmails.split(';').map(x => x.trim()).filter(x => x);
                      const invalids = manualArr.filter(x => !validateEmail(x));
                      if (invalids.length > 0) {
                        setManualEmailError(`Invalid email(s): ${invalids.join('; ')}`);
                        return;
                      }
                      setManualEmailError("");
                      // Remove any emails from emailList which is not present in manualEmails
                      const manual = manualArr.filter(x => !emailList.includes(x));
                      const filteredEmailList = emailList.filter(email => manualEmails.includes(email));
                      //const selected = emails.filter(em => emailList.includes(em));
                      const merged = Array.from(new Set([...filteredEmailList, ...manual]));
                      setEmails(merged);
                    }}
                    placeholder="Enter emails or use Add..."
                    error={!!manualEmailError}
                    helperText={manualEmailError}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleOpenEmailDialog}
                    disabled={actionType === 'delete'}
                    sx={{ minWidth: 60 }}
                  >
                  ...
                  </Button>
                  </Box>
                  {/* Show all merged emails below as read-only */}
                  {emailError && (
                    <FormHelperText error>Email is required.</FormHelperText>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ flex: 1, minWidth: 250, pt: 2 }}>
                <Typography className="lableFont" title="Subject" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                  Subject:<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                  <TextField
                    error={subjectError}
                    id="Subject"
                    name="ReportNotificationSubject"
                    placeholder="Subscription Subject"
                    maxLength={510}
                    value={subject}
                    onChange={e => setSubject(e.target.value)}
                    disabled={actionType === 'delete'}
                    fullWidth
                    size="small"
                    inputProps={{ maxLength: 510 }}
                  />
                  {subjectError && (
                    <FormHelperText error>Subject is required.</FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Box>
          </div>
          <div className="flexWrapGap">
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '1rem', mb: 0.1 }}>Schedule Settings</Typography>
            <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 1, p: 2, gap: 2 }}>
              <Box sx={{ flex: 1, display: 'flex' }}>
                <Box sx={{ flex: 1, minWidth: 250 }} >
                  <Typography className="lableFont" title="Time Zone" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                    Time Zone:<span style={{ color: 'red' }}>*</span>
                  </Typography>

                  <FormControl fullWidth size="small" sx={{ mt: 1 }} error={timeZoneError}>
                    <Select
                      labelId="timeZone-label"
                      id="timeZone"
                      value={timeZoneOptions.some(z => z.id === timeZone) ? timeZone : ''}
                      onChange={handleTimeZoneChange}
                      sx={{ minWidth: 250, width: '100%' }}
                      disabled={actionType === 'delete'}
                      displayEmpty
                    >
                      <MenuItem value=""><em>Select Time Zone</em></MenuItem>
                      {timeZoneOptions.map((zone) => (
                        <MenuItem key={zone.id} value={zone.id}>
                          {zone.displayName}
                        </MenuItem>
                      ))}
                    </Select>
                    {timeZoneError && (
                      <FormHelperText error>Time zone is required.</FormHelperText>
                    )}
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1, minWidth: 250, pt: 2, paddingLeft: 8 }}>
                  <FormControl fullWidth size="small" sx={{ mt: 1 }} >
                    <RadioGroup
                      row
                      aria-labelledby="recurrence-pattern-group"
                      name="recurrencePattern"
                      value={recurrencePattern}
                      onChange={handleRecurrencePatternChange}
                      disabled={actionType === 'delete'}
                    >
                      {recurrencePatterns.map((pattern) => (
                        <FormControlLabel 
                          key={pattern} 
                          control={<Radio disabled={actionType === 'delete'} />} 
                          label={pattern} 
                          value={pattern}
                          disabled={actionType === 'delete'}
                        />
                      ))}
                    </RadioGroup>

                  </FormControl>
                </Box>
              </Box>
              <Box sx={{ flex: 1, display: 'flex', pt: 2, gap: 2, width: '100%', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                <Box sx={{ flex: 1, minWidth: 200 }} >
                  <Typography className="lableFont" title="Start Date" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                    Start Date:<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" sx={{ mt: 1 }} error={startDateError}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enUS}>
                      <DatePicker
                        value={startDate}
                        onChange={(newValue) => {
                          setStartDate(newValue);
                          setStartDateError(!newValue);
                        }}
                        minDate={(!startDate) ? (() => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(0,0,0,0); return d; })() : undefined}
                        slotProps={{
                          textField: {
                            size: 'small',
                            variant: 'outlined',
                            margin: 'dense',
                            sx: {
                              fontSize: 14,
                              height: 40,
                              padding: '0px 16px 0px 0px',
                            },
                          },
                        }}
                        disabled={actionType === 'delete'}
                      />
                    </LocalizationProvider>
                    {startDateError && (
                      <FormHelperText error>Start date is required.</FormHelperText>
                    )}
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1, width: '50px' }} >
                  <Typography className="lableFont" title="End Date" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                    End Date:<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" sx={{ mt: 1 }} error={endDateError}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enUS}>
                      <DatePicker
                        value={endDate}
                        onChange={(newValue) => {
                          setEndDate(newValue);
                          // Validation: End Date must be greater than Start Date
                          if (!newValue || !startDate || newValue <= startDate) {
                            setEndDateError(true);
                          } else {
                            setEndDateError(false);
                          }
                        }}
                        minDate={startDate ? new Date(startDate.getTime() + 24*60*60*1000) : undefined}
                        slotProps={{
                          textField: {
                            size: 'small',
                            variant: 'outlined',
                            margin: 'dense',
                            sx: {
                              fontSize: 14,
                              height: 40,
                              padding: '0px 16px 0px 0px',
                            },
                          },
                        }}
                        disabled={actionType === 'delete'}
                      />
                    </LocalizationProvider>
                    {endDateError && (
                      <FormHelperText error>End date must be greater than Start date.</FormHelperText>
                    )}
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1, width: '50px' }} >
                  <Typography className="lableFont" title="Send Time" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                    Send Time:<span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" sx={{ mt: 1 }} >
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enUS}>
                      <TimePicker
                        value={sendTime}
                        onChange={(newValue) => {
                          setSendTime(newValue);
                          setSendTimeError(!newValue);
                        }}
                        ampm={true}
                        slotProps={{
                          textField: {
                            size: 'small',
                            variant: 'outlined',
                            margin: 'dense',
                            sx: {
                              fontSize: 14,
                              height: 40,
                              padding: '0px 16px 0px 0px',
                            },
                          },
                        }}
                        disabled={actionType === 'delete'}
                      />
                    </LocalizationProvider>
                    {sendTimeError && (
                      <FormHelperText error>Send time is required.</FormHelperText>
                    )}
                  </FormControl>
                </Box>
                <Box sx={{ flex: 1, width: '50px', visibility: recurrencePattern === 'Weekly' || recurrencePattern === 'Monthly' ? 'visible' : 'hidden' }} >
                  {recurrencePattern === 'Weekly' && (
                    <Box sx={{ flex: 1, width: '200px' }}>
                      <Typography className="lableFont" title="Week day" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                        Week day:<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <FormControl fullWidth size="small" sx={{ mt: 2 }} error={selectedWeekDaysError}> 
                        <Select
                          labelId="weekDays-label"
                          id="weekDays"
                          value={selectedWeekDays.length ? selectedWeekDays : []}
                          onChange={e => setSelectedWeekDays(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                          renderValue={(selected) => Array.isArray(selected) && selected.length ? selected.join(', ') : 'Select week day'}
                          sx={{ minWidth: 80, width: '50%' }}
                          disabled={actionType === 'delete'}
                          multiple
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            <em>Select week day(s)</em>
                          </MenuItem>
                          {weekDays.map((day) => (
                            <MenuItem key={day} value={day}>
                              <Checkbox checked={selectedWeekDays.includes(day)} />
                              <ListItemText primary={day} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {selectedWeekDaysError && (
                        <FormHelperText error>Please select at least one week day.</FormHelperText>
                      )}
                    </Box>
                  )}
                  {recurrencePattern === 'Monthly' && (
                    <Box sx={{ flex: 1, width: '200px' }} >
                      <Typography className="lableFont" title="Days" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                        Days:<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <Typography className="lableFont" title="Day of month" sx={{ verticalAlign: 'middle', mr: 1 }}>
                            Day
                          </Typography>
                          <TextField
                            id="txtMonthlyPattern"
                            // type="number"
                            value={selectedDayOfMonth}
                            onChange={e => {
                              const val = e.target.value;
                              setSelectedDayOfMonth(val);
                              setSelectedDayOfMonthError(!(val >= 1 && val <= 31));
                            }}
                            inputProps={{ min: 1, max: 31, maxLength: 2 }}
                            placeholder="day"
                            size="small"
                            sx={{ width: '50px', display: 'inline-block' }}
                            disabled={actionType === 'delete'}
                            error={selectedDayOfMonthError && recurrencePattern === 'Monthly'}
                          />
                          <Typography className="lableFont" title="Day of month" sx={{ verticalAlign: 'middle', ml: 1 }}>
                            of Every Month
                          </Typography>
                        </Box>
                        {selectedDayOfMonthError && (
                          <FormHelperText error>Enter a valid day (1-31).</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </Box>

            </Box>
            </Box>
          </div>
          <div className="flexWrapGap">
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.1 }}>
                <Typography sx={{ fontWeight: 600, fontSize: '1rem', mr: 1 }}>Email Template</Typography>
                <Tooltip title="Custom Message entered on the right hand box will be replaced in place of {customMessage} in email template along with other standard field replacements while sending Subscription Email." tabIndex={-1}>
                   {/* <InfoIcon style={{ width: 30, height: 30, marginRight: 1, color: '#333' }} /> */}
                  <IconButton size="small" sx={{ p: 0.1 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" style={{ fill: '#1976d2' }}>
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M11 17h2v-6h-2v6zm0-8h2V7h-2v2zm1-7C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                    </svg>
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 1, p: 2 }}>
                <Box sx={{ flex: 1, display: 'flex', gap: 2 }}>
                  <Box sx={{ flex: 1, minWidth: 250 }} >
                    <Typography className="lableFont" title="Email Template" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                      Template to use (Read Only)
                    </Typography>
                    <TextField
                      id="txtEmailTemplate"
                      value={emailTemplate.body}                
                      placeholder="Enter email template"
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1 }}
                      disabled
                    />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 250 }} >
                    <Typography className="lableFont" title="Custom Message" sx={{ verticalAlign: 'middle', fontWeight: 600 }}>
                      Custom Message
                    </Typography>
                    <TextField
                      id="txtEmailTemplate"
                      value={customMessage}
                      onChange={e => setCustomMessage(e.target.value)}
                      placeholder="Enter custom message"
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1 }}
                      disabled={actionType === 'delete'}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end', pr: 3, pb: 1 }}>
          <Button variant="contained" type="submit" color="primary">{buttonText}</Button>
          <Button variant="outlined" color="primary" onClick={handleClose}>Cancel</Button>

        </DialogActions>
      </Box>
      <Dialog open={emailDialogOpen} onClose={handleCloseEmailDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Select Emails 
          {/* X Button */}
          <IconButton onClick={() => setEmailDialogOpen(false)}  sx={{ position: "absolute", right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {/* Search Field */}
         <TextField
            fullWidth
            variant="outlined"
            placeholder="Search emails"
            size="small"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* No results */}
          <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
            {filteredEmails.length === 0 && (
              <Typography variant="body2">No emails found.</Typography>
            )}

            {/* Email list */}
            {filteredEmails.map(email => (
              <MenuItem key={email} sx={{py:0.2}} onClick={() => handleEmailDialogChange(email)}>
                <Checkbox
                  checked={emailDialogSelection.includes(email)}
                  onChange={() => handleEmailDialogChange(email)}
                  onClick={(e) => e.stopPropagation()}
                />
                <ListItemText primary={email} />
              </MenuItem>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEmailDialog}>Cancel</Button>
          <Button onClick={handleEmailDialogConfirm} variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
export default SubscriptionMgt;